export default class Terrain3d {
  constructor({ map, exaggeration = 1 }) {
    if (!map) {
      throw new Error('Must pass map to Terrain3d widget');
    }

    this.map = map;
    this.exaggeration = exaggeration;
  }

  isShowing() {
    return !!this.map.getSource('mapbox-dem');
  }

  toggle() {
    if (this.isShowing()) {
      this.hide();
      return 'off';
    } else {
      this.show();
      return 'on';
    }
  }

  show({ setPitch = true } = {}) {
    if (this.isShowing()) return;

    this.map.addSource('mapbox-dem', {
      'type': 'raster-dem',
      'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
      'tileSize': 512,
      'maxzoom': 14
    });

    this.map.setTerrain({
      'source': 'mapbox-dem',
      'exaggeration': this.exaggeration
    });
    if (setPitch && this.map.getPitch() < 30) {
      this.map.easeTo({ pitch: 60, duration: 3000 });
    }
  }

  hide() {
    if (!this.isShowing()) return;

    this.map.setTerrain();
    this.map.removeSource('mapbox-dem');
    if (this.map.getPitch() > 0) {
      this.map.easeTo({ pitch: 0 });
    }
  }
}
